import React from "react";
import { formatCurrency } from "../../utils/formatters";

export default function TransactionList({ transactions, accountType }) {
    if (!transactions || transactions.length === 0) {
        return <p className="text-gray-500">No transactions found.</p>;
    }

    const isCreditCard = accountType?.toLowerCase() === "credit";

    return (
        <div className="overflow-x-auto">
            <table className="w-full">
                <thead>
                    <tr className="border-b border-gray-200">
                        <th className="text-left text-sm font-medium text-gray-500 pb-3 pr-4">Date</th>
                        <th className="text-left text-sm font-medium text-gray-500 pb-3">Description</th>
                        <th className="text-right text-sm font-medium text-gray-500 pb-3 pr-6">Amount</th>
                        <th className="text-left text-sm font-medium text-gray-500 pb-3">Category</th>
                    </tr>
                </thead>
                <tbody>
                    {transactions.map((t) => {
                        const isPayment = t.category === "Payment" ||
                            (t.name && t.name.toLowerCase().includes("payment"));

                        let isExpense, prefix;
                        if (isCreditCard) {
                            // Credit cards: charges = $X red, payments = -$X green
                            isExpense = t.amount > 0 && !isPayment;
                            prefix = isPayment ? "-" : "";
                        } else {
                            // Checking/savings: expenses = -$X red, income = $X green
                            isExpense = t.amount > 0;
                            prefix = isExpense ? "-" : "";
                        }

                        return (
                            <tr key={t.transactionId} className="border-b border-gray-200">
                                <td className="py-3 text-gray-500 text-sm pr-4">{t.date}</td>
                                <td className="py-3 text-gray-900">{t.name}</td>
                                <td className={`py-3 text-right font-medium pr-6 ${isExpense ? "text-danger-500" : "text-accent-600"}`}>
                                    {prefix}{formatCurrency(Math.abs(t.amount))}
                                </td>
                                <td className="py-3 text-gray-500 text-sm">{t.category}</td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
}
